import { render } from "./CreateRealEstate.vue?vue&type=template&id=8a3ef768&scoped=true"
import script from "./CreateRealEstate.vue?vue&type=script&lang=js"
export * from "./CreateRealEstate.vue?vue&type=script&lang=js"

import "./CreateRealEstate.vue?vue&type=style&index=0&id=8a3ef768&lang=css"
import "./CreateRealEstate.vue?vue&type=style&index=1&id=8a3ef768&scoped=true&lang=css"
import "./CreateRealEstate.vue?vue&type=style&index=2&id=8a3ef768&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a3ef768"]])

export default __exports__